import {RaEvent} from "../../event/RaEvent";
import {PreviewStepEvent, ReadAndRecordStepEvent, QuizStepEvent, WordWallStepEvent} from "../../event/StepEvents";
import {BookSessionType} from "../../constants";

export interface IStep {
    getEvent(): RaEvent;
    getType(): BookSessionType;
    getNext(): IStep;

    equals(IStep): boolean;
}

export abstract class BaseStep implements IStep {
    abstract getEvent():RaEvent;
    abstract getType():BookSessionType;
    abstract getNext():IStep;

    public equals(step: IStep ): boolean {
        return this.getType() === step.getType();
    }
}

export class WordWallStep extends BaseStep {

    public getEvent():RaEvent {
        return new WordWallStepEvent();
    }

    public getType():BookSessionType {
        return BookSessionType.WORDWALL;
    }

    public getNext():IStep {
        return new PreviewStep();
    }

}

export class PreviewStep extends BaseStep {

    public getEvent():RaEvent {
        return new PreviewStepEvent();
    }

    public getType():BookSessionType {
        return BookSessionType.PREVIEW;
    }

    public getNext():IStep {
        return new ReadAndRecordStep();
    }

}

export class ReadAndRecordStep extends BaseStep {

    public getEvent():RaEvent {
        return new ReadAndRecordStepEvent();
    }

    public getType():BookSessionType {
        return BookSessionType.FLUENCY;
    }

    public getNext():IStep {
        return new QuizStep();
    }
}

export class QuizStep extends BaseStep {

    public getEvent():RaEvent {
        return new QuizStepEvent();
    }

    public getType():BookSessionType {
        return BookSessionType.QUIZ;
    }

    public getNext():IStep {
        return new PreviewStep();
    }
}
